import {
  LEAVE_YEAR_FETCHING,
  LEAVE_YEAR_FAILED,
  LEAVE_YEAR_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
      case LEAVE_YEAR_FETCHING:
          return { ...state, result: null, isFetching: true, isError: false };
      case LEAVE_YEAR_FAILED:
          return { ...state, result: null, isFetching: false, isError: true };
      case LEAVE_YEAR_SUCCESS:
          return { ...state, result: payload, isFetching: false, isError: false };
      default:
          return state;
  }
};